/**
 * Generate a UUID v4 using native crypto.randomUUID
 */
export function generateUUID(): string {
  return crypto.randomUUID()
}
